<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-body">
            <form [formGroup]="lienholderInformation">
                <div class="row">
                    <div class="form-group col-md col-sm-12">
                        <label for="financesSaleType">Finance Sale Type</label>
                        <select class="form-select form-control form-control-sm" id="financesSaleType" formControlName="financesSaleType">
                            @for (type of financingOptions; track type.id) {
                                <option [value]="type.id">{{type.name}}</option>
                            }
                        </select>
                    </div>
                    <div class="form-group col-md col-sm-12">
                        <label for="stateFormId">Contract Used</label>
                        <select class="form-select form-control form-control-sm" id="stateFormId" formControlName="stateFormId">
                            @for (contract of contracts; track contract.id) {
                                <option [value]="contract.id">{{contract.name}} {{contract.producer}} {{contract.revision}}</option>
                            }
                        </select>
                    </div>
                    <div class="form-group col-md col-sm-12">
                        <label for="defaultCollectionMethod">Default Collection Method</label>
                        <select class="form-select form-control form-control-sm" id="defaultCollectionMethod" formControlName="defaultCollectionMethod">
                            @for (method of collectionMethods; track method) {
                                <option [value]="method">{{method}}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md col-sm-12">
                        <label for="comprehensiveDeductible">Comprehensive Deductible</label>
                        <currency-input [id]="'comprehensiveDeductible'" [control]="lienholderInformation.get('comprehensiveDeductible')"></currency-input>
                    </div>
                    <div class="form-group col-md col-sm-12">
                        <label for="collisionDeductible">Collision Deductible</label>
                        <currency-input [id]="'collisionDeductible'" [control]="lienholderInformation.get('collisionDeductible')"></currency-input>
                    </div>
                    <div class="form-group col-md col-sm-12">
                        <label for="splitRate">Finance Participation Split Rate</label>
                        <percent-input [id]="'splitRate'" [control]="lienholderInformation.get('splitRate')"></percent-input>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="certifiedId">Certified Lienholder ID No.</label>
                        <input type="text" class="form-control form-control-sm" formControlName="certifiedId" />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group form-check col-md col-sm-12">
                        <input type="checkbox" class="form-check-input" id="deductWarranty" formControlName="deductWarranty" />
                        <label class="form-check-label" for="deductWarranty">Deduct Warranty Cost from Contract Amount in Contracts In Transit</label>
                    </div>
                    <div class="form-group form-check col-md col-sm-12">
                        <input type="checkbox" class="form-check-input" id="deductGap" formControlName="deductGap" />
                        <label class="form-check-label" for="deductGap">Deduct GAP Cost from Contract Amount in Contracts In Transit</label>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group form-check col-md col-sm-12">
                        <input type="checkbox" class="form-check-input" id="hideNameOnContract" formControlName="hideNameOnContract" />
                        <label class="form-check-label" for="hideNameOnContract">Print Dealership (instead of Lienholder) as contact in OCCC Notice</label>
                    </div>
                    <div class="form-group form-check col-md col-sm-12">
                        <input type="checkbox" class="form-check-input" id="electronicTitle" formControlName="electronicTitle" />
                        <label class="form-check-label" for="electronicTitle">Electronic Title Request</label>
                    </div>
                </div>
            </form>
        </div>
        <div class="card-footer text-right">
            @if (calledFrom !== null) {
                <button class="btn btn-sm btn-link"><span class="text-danger">cancel &amp; close</span></button>
            }
            <button class="btn btn-sm btn-primary" (click)="save()" [disabled]="!lienholderInformation.valid || contactId == 0">Save</button>
        </div>
    </div>
    @if (calledFrom == null) {
        <div class="text-right">
            <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
        </div>
    }
</div>
